import React, { useRef, useState } from 'react'
import { Toolbar, styled } from '~/app/components'
import useToolbarScroll from '~/app/components/common/Toolbar/useToolbarScroll'
import { Popup } from '@yanolja-org/ya-com-popup'
import { Layout, ContentContainer, Content } from '~/app/components/layout-style'
import { Notice } from '~/app/components/order-list/common/OrderDetailsCommonStyled'
import { OrderReceipt } from '~/app/components/order-list/hooks/useReceiptInfo'
import ReceiptItem from './ReceiptItem'

interface ReceiptModalContentProps {
  onClickBack: () => void
  orderReceipts: OrderReceipt[]
}

const ReceiptListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`

const ReceiptModalContent: React.FC<ReceiptModalContentProps> = ({
  onClickBack,
  orderReceipts,
}) => {
  const scrollTarget = useRef<HTMLDivElement>(null)
  const { hasShadow } = useToolbarScroll(scrollTarget)
  const [pgReceiptErrorMessage, setPgReceiptErrorMessage] = useState<string>('')

  const closePgReceiptErrorPopup = () => {
    setPgReceiptErrorMessage('')
  }

  return (
    <Layout>
      <Toolbar
        title={'영수증 조회'}
        type={'close'}
        onClickBackButton={onClickBack}
        hasShadow={hasShadow}
      />
      <ContentContainer>
        <Content ref={scrollTarget} style={{ padding: 0, justifyContent: 'flex-start' }}>
          <ReceiptListSection>
            {orderReceipts.map(({ receiptInformation: information, ...props }) => (
              <ReceiptItem
                key={information.id}
                information={information}
                {...props}
                onFetchPgReceiptError={error => {
                  setPgReceiptErrorMessage(error.message)
                }}
              />
            ))}
          </ReceiptListSection>
          <Notice>
            <ul>
              <li>
                예약영수증은 세금계산서 등 세무상 증빙서류가 아닌 거래 내역 및 거래 금액을 확인하는
                용도로만 활용할 수 있습니다.
              </li>
              <li>
                신용카드 매출전표는 결제완료 시 자동 발급되며, 예약완료 후 확인할 수 있습니다.
              </li>
            </ul>
          </Notice>
        </Content>
      </ContentContainer>
      <Popup
        popupId={'PG_RECEIPT_ERROR'}
        buttons={[{ id: 'confirm', title: '확인', isPrimary: true }]}
        isOpened={!!pgReceiptErrorMessage}
        title={pgReceiptErrorMessage}
        onButtonClick={closePgReceiptErrorPopup}
        onBackgroundClick={closePgReceiptErrorPopup}
        onPopupClose={closePgReceiptErrorPopup}
      />
    </Layout>
  )
}

export default ReceiptModalContent
